import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import swManager from '../serviceWorker/swManager';

import { useAuth } from 'services/auth';

import LoginScreen from 'screens/LoginScreen';
import ForgotPasswordScreen from 'screens/ForgotPasswordScreen';
import PasswordResetEmailSentScreen from 'screens/PasswordResetEmailSentScreen';
import JobsScreen from 'screens/JobsScreen';
import NewJobScreen from 'screens/NewJobScreen';
import NotFoundScreen from 'screens/NotFoundScreen';
import AdminScreen from 'screens/AdminScreen';
import LocationsScreen from 'screens/LocationsScreen';
import PricebooksScreen from 'screens/PricebooksScreen';

import { NewJobProvider } from 'services/reducers/newJob';
import { useNotifications } from 'services/notification';
import { LocationProvider } from 'services/location';
import { RepairerProvider } from 'services/repairer';
import { EstimateProvider } from 'services/estimate';
import { useApp } from 'contexts/AppContext';
import { useError } from 'contexts/ErrorContext';
import { ChatProvider } from 'contexts/ChatContext';
import { JobsProvider } from 'services/job/context';
import { CompanyProvider } from 'services/company';
import SendBirdService from 'services/sendBird/sendBirdService';
import ChatDock from 'components/Sendbird/ChatDock';

import LoginLayout from './LoginLayout';
import Layout from './Layout';
import AuthenticatedRoute from './AuthenticatedRoute';
import UnauthenticatedRoute from './UnauthenticatedRoute';

const Router = () => {
    const auth = useAuth();
    const user = auth.state;
    const app = useApp();
    const notificationContext = useNotifications();
    const errorContext = useError();

    const newNotificationHandler = async (notification) => {
        notificationContext.actions.addFCMNotification(
            notification.data.message_id,
            notification.data.job_id,
            notification.data.service_id,
            notification.notification.title,
            notification.timestamp,
        );
    };

    useEffect(() => {
        if (app && user.loggedIn) {
            swManager.initialize(app, newNotificationHandler);
            notificationContext.actions.refreshNotifications(errorContext);
        }
    }, [app, user.loggedIn]);

    return (
        <>
            <SendBirdService>
                <JobsProvider>
                    <CompanyProvider>
                        <ChatProvider>
                            <LocationProvider>
                                <RepairerProvider>
                                    <EstimateProvider>
                                        <NewJobProvider>
                                            <Routes>
                                                <Route element={<UnauthenticatedRoute user={user} />}>
                                                    <Route path='/login' element={<LoginLayout />}>
                                                        <Route index element={<LoginScreen />} />
                                                        <Route path='forgot_password' element={<ForgotPasswordScreen />} />
                                                        <Route
                                                            path='password_reset_email_sent'
                                                            element={<PasswordResetEmailSentScreen /> }
                                                        />
                                                    </Route>
                                                </Route>
                                                <Route element={<AuthenticatedRoute user={user} />}>
                                                    <Route path='/' element={<Layout />}>
                                                        <Route index element={<JobsScreen />} />
                                                        <Route path='new_job' element={ <NewJobScreen /> } />
                                                        <Route path='jobs' element={<JobsScreen />} />
                                                        <Route path='admin' element={<AdminScreen />} />
                                                        <Route path='locations' element={<LocationsScreen />} />
                                                        <Route path='pricebooks' element={<PricebooksScreen />} />
                                                    </Route>
                                                </Route>
                                                <Route path='*' element={<NotFoundScreen />} />
                                            </Routes>
                                            <ChatDock />
                                        </NewJobProvider>
                                    </EstimateProvider>
                                </RepairerProvider>
                            </LocationProvider>
                        </ChatProvider>
                    </CompanyProvider>
                </JobsProvider>
            </SendBirdService>
        </>
    );
};

export default Router;
